<template>
	<div class id="scratchpad">
		<div class>
			<div @click="minimize" class="scratchpad-header py-2 px-3">
				<p class="mb-0">
					Scratch Pad
					<span class="pl-1" :class="{ green: is_saved, orange: !is_saved }">
						<small>
							<i class="fas fa-circle"></i>
						</small>
					</span>
				</p>
				<a href="#" v-show="show" class="right white-text">
					<i class="fas fa-minus"></i>
				</a>
				<a href="#" v-show="!show" class="right white-text">
					<i class="fas fa-plus"></i>
				</a>
				<!-- <i class="far fa-window-minimize"></i> -->
			</div>

			<transition name="padslide">
				<div ref="scratchbody" class="scratchpad-body border py-2 px-2" v-show="show">

					<textarea :disabled="savingNote" class="w-100 p-2" rows="10" @input="notesUpdateListener" v-model="notes"></textarea>

                    <el-row :gutter="10">
                        <el-col :span="10">
                            <el-button @click="saveNote(false)" :disabled="savingNote" class="w-100" size="small" type="success">Save Note</el-button>
                        </el-col>
                        <el-col :span="14">
                            <el-button @click="saveNote(true)" :disabled="savingNote" class="w-100" size="small" type="success">Save Note and Clear</el-button>
                        </el-col>
                    </el-row>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import { Message } from "element-ui"
	export default {
		name: "ScratchPad",
		data() {
			return {
				notes: "",
				is_saved: true,
				timeout: null,
				show: false,
                savingNote: false
				//expanded: true
			}
		},
		created() {
            
			this.notes = this.$store.getters['notes/scratch'](this.$store.getters.initAppData.id)

            console.warn('notes', this.notes)

			// if (this.notes) {
			// 	this.notes = this.notes
			// }
		},
		methods: {
			apiToken() {
				return {
					headers: { Authorization: "Bearer " + this.$store.getters.token },
				}
			},
			saveNote(clear) {
                this.savingNote = true
				axios
					.post(
						"/api/notes",
						{
							title: "ScratchPad",
							notes: this.notes,
							application_id: this.$store.getters.initAppData.id,
							is_referrer_visible: this.$store.getters["user_roles/is_referrer"],
						},
						this.apiToken()
					)
					.then((res) => {

						this.$store.dispatch("notes/saveNote", res.data)
                        
						Message({
							message: "Note Created.",
							type: "success",
						})

                        if (clear) {
                            this.notes = ""
                            this.$store.dispatch("notes/deleteScratch", this.$store.getters.initAppData.id)
                        }
					})
					.catch((err) => {
						Message({
							message: "Note cannot be created.",
							type: "error",
						})
						console.error(err)
					})
                    .finally(() => {
                        this.savingNote = false
                    })
			},
			notesUpdateListener() {

				this.is_saved = false

				if (this.timeout) {
					clearTimeout(this.timeout)
				}

				// fire an update event every 450 ms after typing instead of every key up event;
				// to prevent flooding the messaging queue
				this.timeout = setTimeout(() => {
					this.updateNotes()
				}, 450)
				// make the timeout very short incase the user immediately close the application (go back or going to other pages), refresh it, etc
			},
			updateNotes() {
				this.is_saved = true

                this.$store.dispatch('notes/saveScratch', {
                    applicationId: this.$store.getters.initAppData.id,
                    note: this.notes
                })

				// window.Echo.private(`loan_option.` + window.Tenant + "." + this.$store.getters.initAppData.id).whisper("NotesUpdated", {
				// 	notes: this.notes,
				// 	tenant_id: window.Tenant,
				// 	application_id: this.$store.getters.initAppData.id,
				// })
			},
			minimize() {
				this.show = !this.show
				//this.$refs.scratchbody
			},
		},
	}
</script>

<style lang="scss" scoped>
	.orange {
		color: #f28f1c;
	}

	.green {
		color: #5cbb2a;
	}

	.scratchpad-body {
		height: 300px;
        padding: 10px 10px 20px 10px !important;
        background-color: #294da5 !important;
        border: none !important;

		textarea {
			box-shadow: none !important;
		}
	}

	.padslide-enter-active,
	.padslide-leave-active {
		transition: 0.2s all ease-in-out;
	}

	.padslide-enter,
	.padslide-leave-to {
		height: 0;
	}
</style>
